import { createContext, useContext, useEffect, useState } from "react";

interface IsMobileContextType {
  isMobile: boolean;
}

const IsMobileContext = createContext<IsMobileContextType>({ isMobile: false });

export function IsMobileProvider({ children }: { children: React.ReactNode }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <IsMobileContext.Provider value={{ isMobile }}>
      {children}
    </IsMobileContext.Provider>
  );
}

export function useIsMobile() {
  return useContext(IsMobileContext);
}
